import React, { useEffect, useState } from "react";
import * as go from "gojs";
import { GojsConstant } from "src/constants/GojsConstant";
import { checkEmpty } from "src/utils/janus.utils";
import { ChartTemplate } from "./ChartTemplate/ChartTemplate";

export let MyDiagramState: go.Diagram;
export let IsAlreadyAddLinkDrawnState = false;
export let SelectionNodeState: any;
export let currentNodeState: any;
export let currentEvent: any;

let defualtProfileUrl = window.location.origin + "/center-web/images/user.png";
const $$ = go.GraphObject.make;

let Event = {
  UpdateNode: "UpdateNode"
}

let JsonTestGojs = {
  "class": "go.TreeModel",
  "nodeDataArray": [
    { "key": 1, "type":"person","name": "Stella Payne Diaz", "position": "CEO", "profileUrl": "https://mocha.centerapp.io/center/api/v1/files/profile?file=359fefa7-0e72-4ada-be16-ab2d2368c4e8&name=disper1412@gmail.com&bucket=profile" },
    { "key": 2, "type":"person","name": "Luke Warm", "position": "VP Marketing/Sales", "profileUrl": "https://cdn.theorg.com/3a008436-a527-46ce-8406-59414fff1df6_thumb.jpg", "parent": 1 },
    { "key": 3, "type":"person","name": "Meg Meehan Hoffa", "position": "Sales", "pic": "3.jpg", "parent": 2 },
    { "key": 4, "type":"person","name": "Peggy Flaming", "position": "VP Engineering", "pic": "4.jpg", "parent": 1 },
    { "key": 5, "type":"person","name": "Saul Wellingood", "position": "Manufacturing", "pic": "5.jpg", "parent": 4 },
    { "key": 6, "type":"person","name": "Al Ligori", "position": "Marketing", "pic": "6.jpg", "parent": 2 },
    { "key": 7, "type":"person","name": "Dot Stubadd", "position": "Sales Rep", "pic": "7.jpg", "parent": 3 },
    { "key": 8, "type":"person","name": "Les Ismore", "position": "Project Mgr", "pic": "8.jpg", "parent": 5 },
    { "key": 9, "type":"person","name": "April Lynn Parris", "position": "Events Mgr", "pic": "9.jpg", "parent": 6 },
    { "key": 10, "type":"person","name": "Xavier Breath", "position": "Engineering", "pic": "10.jpg", "parent": 4 },
    { "key": 11, "type":"person","name": "Anita Hammer", "position": "Process", "pic": "11.jpg", "parent": 5 },
    { "key": 12, "type":"person","name": "Billy Aiken", "position": "Software", "pic": "12.jpg", "parent": 10 },
    { "key": 13, "type":"person","name": "Stan Wellback", "position": "Testing", "pic": "13.jpg", "parent": 10 },
    { "key": 14, "type":"person","name": "Marge Innovera", "position": "Hardware", "pic": "14.jpg", "parent": 10 },
    { "key": 15, "type":"person","name": "Evan Elpus", "position": "Quality", "pic": "15.jpg", "parent": 5 },
    { "key": 16, "type":"person","name": "Lotta B. Essen", "position": "Sales Rep", "pic": "16.jpg", "parent": 3 },
    { "key": 17, "type":"organization","name": "Org Name", "position": "Organization", "pic": "16.jpg", "parent": 3 }
  ]
};
// let JsonTestGojs = {
//   "class": "go.TreeModel",
//   "nodeDataArray": [
 
//   ]
// };


const OrgChart = (props: any) => {

  const [currentName, setCurrentName] = useState("");
  const [currentPosition, setCurrentPosition] = useState("");
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    initDiagram();
    let config = reflectorConfig(JsonTestGojs)
    console.log("config : ", config)
    loadDataToDiagram(config);
    var x = getDataFromDiagram();
  }, []);

  const reflectorConfig = (config: any) => {
    let nodeDataArray = config.nodeDataArray;
    for (let a = 0; a < nodeDataArray.length; a++) {
      let key = nodeDataArray[a].key;
      let childs = nodeDataArray.filter((item: any) => item?.parent === nodeDataArray[a].key)
      nodeDataArray[a].childCount = childs.length;
    }
    config.nodeDataArray = nodeDataArray;
    return config;
  }




  function getDataFromDiagram() {
    console.log("MyDiagramState.model.toJson(); ", MyDiagramState.model.toJson());
    return MyDiagramState.model.toJson();
  }
  function loadDataToDiagram(json: any) {
    MyDiagramState.model = go.Model.fromJson(json);
    let lastkey = 1;
    MyDiagramState.model.makeUniqueKeyFunction = (model: any, data: any) => {
      let k = data.key || lastkey;
      while (model.findNodeDataForKey(k)) k++;
      data.key = lastkey = k;
      return k;
    };
  }

  function updateCurrentNode() {
    if (currentEvent === Event.UpdateNode) {


      let node: any = MyDiagramState.findNodeForKey(currentNodeState?.data.key);
      let childCountCurrent = 1;
      if (!checkEmpty(node?.data?.childCount)) {
        childCountCurrent = node?.data?.childCount + 1
      }

      MyDiagramState.model.commit(m => {  // m == the Model
        // m.set(node.data, "childCount", childCountCurrent);
        m.set(node.data, "name", currentName);
        m.set(node.data, "position", currentPosition);
        m.set(node.data, "profileUrl", currentUrl);
      }, "changed childCount");
    }

  }
  function selectCurrentNode(node: any, eventName: any) {
    console.log("node", node.data)
    // console.log("eventName", eventName)
    currentNodeState = node;
    if (eventName === "doubleClick") {
      currentEvent = Event.UpdateNode;
      let name = currentNodeState?.data?.name?currentNodeState?.data?.name:""
      let position= currentNodeState?.data?.position?currentNodeState?.data?.position:""
      let profileUrl = currentNodeState?.data?.profileUrl?currentNodeState?.data?.profileUrl:"";
      setCurrentName(name)
      setCurrentPosition(position)
      setCurrentUrl(profileUrl)
    }
  }

  const clickOpenNode = (node:any)=>{
    console.log("clickOpenNode node", node.data)
  }



  function addEmployee(node: any) {
    console.log("node", node)

    if (!checkEmpty(node)) {

      const thisemp = node.data;
      MyDiagramState.startTransaction("add employee");

      currentNodeState = MyDiagramState.findNodeForKey(thisemp.key);
      let childCountCurrent = 1;
      if (!checkEmpty(currentNodeState?.data?.childCount)) {
        childCountCurrent = parseInt(currentNodeState?.data?.childCount) + 1
      }

      MyDiagramState.model.commit(m => {  // m == the Model
        m.set(node.data, "childCount", childCountCurrent);
      }, "changed childCount");

      const newemp = { name: "(new person)", position: "(position)", comments: "", parent: thisemp.key, childCount: 0 };
      MyDiagramState.model.addNodeData(newemp);
      // const newnode = MyDiagramState.findNodeForData(newemp);
      // if (newnode) newnode.location = node.location;
      MyDiagramState.commitTransaction("add employee");
      // MyDiagramState.commandHandler.scrollToPart(newnode);
      MyDiagramState.requestUpdate()
    } else {
      MyDiagramState.startTransaction("add employee");
      const newemp = { name: "(new person)", position: "(position)", comments: "", childCount: 0 };
      MyDiagramState.model.addNodeData(newemp);
      MyDiagramState.commitTransaction("add employee");
    }

  }

  function removeCurrentNode(node: any) {
    if (node !== null) {

      //           let itObj=MyDiagramState.findNodesByExample({parentKey:key}).iterator;
      // while(itObj.next()){					
      //   ParamState.myDiagram.select(itObj.value);
      // }

      if (!checkEmpty(node?.data?.parent)) {
        console.log("node?.data?.parent", node?.data?.parent)
        let parentNode: any = MyDiagramState.findNodeForKey(node?.data?.parent);
        let childCountCurrent = 0;
        if (!checkEmpty(parentNode?.data?.childCount)) {
          childCountCurrent = parseInt(parentNode?.data?.childCount) - 1
        }
        if (childCountCurrent < 0) {
          childCountCurrent = 0;
        }
        MyDiagramState.model.commit(m => {  // m == the Model
          m.set(parentNode.data, "childCount", childCountCurrent);
        }, "changed childCount");
      }


      MyDiagramState.startTransaction("remove dept");
      //@ts-ignore
      MyDiagramState.removeParts(node.findTreeParts());
      MyDiagramState.commitTransaction("remove dept");
    }
  }



  function initDiagram() {

    // Since 2.2 you can also author concise templates with method chaining instead of GraphObject.make
    // For details, see https://gojs.net/latest/intro/buildingObjects.html
    //@ts-ignore
    if (window.goSamples) goSamples(); // init for these samples -- you don't need to call this
    go.Diagram.licenseKey = GojsConstant.GOJS_LICENSE_KEY;

    // for conciseness in defining templates

    let myDiagram =
      $$(go.Diagram, "myDiagram", // must be the ID or reference to div
        {
          allowCopy: false,
          allowDelete: false,
          //initialAutoScale: go.Diagram.Uniform,
          maxSelectionCount: 1, // users can select only one part at a time
          validCycle: go.Diagram.CycleDestinationTree, // make sure users can only create trees
          "clickCreatingTool.archetypeNodeData": { // allow double-click in background to create a new node
            name: "(new person)",
            title: "",
            comments: ""
          },
          "clickCreatingTool.insertPart": function (loc: any) {  // override to scroll to the new node
            const node = go.ClickCreatingTool.prototype.insertPart.call(this, loc);
            if (node !== null) {

              MyDiagramState.select(node);

              MyDiagramState.commandHandler.scrollToPart(node);

              //@ts-ignore
              MyDiagramState.commandHandler.editTextBlock(node.findObject("NAMETB"));
            }
            return node;
          },
          layout:
            $$(go.TreeLayout,
              {
                treeStyle: go.TreeLayout.StyleLastParents,
                arrangement: go.TreeLayout.ArrangementHorizontal,
                // properties for most of the tree:
                angle: 90,
                layerSpacing: 35,
                // properties for the "last parents":
                alternateAngle: 90,
                alternateLayerSpacing: 35,
                alternateAlignment: go.TreeLayout.AlignmentBus,
                alternateNodeSpacing: 20
              }),
          "undoManager.isEnabled": true // enable undo & redo
        });
    MyDiagramState = myDiagram

    // when the document is modified, add a "*" to the title and enable the "Save" button
    MyDiagramState.addDiagramListener("Modified", (e: any) => {
      const button: any = document.getElementById("SaveButton");
      if (button) button.disabled = !MyDiagramState.isModified;
      const idx = document.title.indexOf("*");
      if (MyDiagramState.isModified) {
        if (idx < 0) document.title += "*";
      } else {
        if (idx >= 0) document.title = document.title.slice(0, idx);
      }
    });



    // override TreeLayout.commitNodes to also modify the background brush based on the tree depth level
    //@ts-ignore
    MyDiagramState.layout.commitNodes = function () {
      //@ts-ignore
      go.TreeLayout.prototype.commitNodes.call(this);  // do the standard behavior
      // then go through all of the vertexes and set their corresponding node's Shape.fill
      // to a brush dependent on the TreeVertex.level value
      //@ts-ignore
      MyDiagramState.layout.network.vertexes.each((v: any) => {
        if (v.node) {
          const color = "#E8ECEF";//levelColors[level];
          const shape = v.node.findObject("SHAPE");
          if (shape) shape.stroke = $$(go.Brush, "Linear", { 0: color, 1: go.Brush.lightenBy(color, 0.05), start: go.Spot.Left, end: go.Spot.Right });
        }
      });
    };

    function dragDropNode(toNode: any, fromNode: any) {
      let currentParentnode: any = MyDiagramState.findNodeForKey(toNode?.data.key);
      let childCountCurrent = 1;
      if (!checkEmpty(currentParentnode?.data?.childCount)) {
        childCountCurrent = parseInt(currentParentnode?.data?.childCount) + 1
      }

      let oldParentChildCountCurrent = 0;
      let oldParentnode: any;
      if (!checkEmpty(fromNode?.data.key)) {
        oldParentnode = MyDiagramState.findNodeForKey(fromNode?.data.key);
        if (!checkEmpty(oldParentnode?.data?.childCount)) {
          oldParentChildCountCurrent = parseInt(oldParentnode?.data?.childCount) - 1
        }
        if (oldParentChildCountCurrent < 0) {
          oldParentChildCountCurrent = 0;
        }
      }

      MyDiagramState.model.commit(m => {  // m == the Model
        m.set(currentParentnode.data, "childCount", childCountCurrent);
        if (!checkEmpty(fromNode?.data.key)) {
          m.set(oldParentnode.data, "childCount", oldParentChildCountCurrent);
        }
      }, "changed childCount");

    }



    // define the Node template
    let chartTemplate = new ChartTemplate()
    MyDiagramState.nodeTemplate = chartTemplate.getNodeTemplate(selectCurrentNode, addEmployee, dragDropNode,clickOpenNode)



    // the context menu allows users to make a position vacant,
    // remove a role and reassign the subtree, or remove a department
    MyDiagramState.nodeTemplate.contextMenu =
      $$("ContextMenu",
        $$("ContextMenuButton",
          $$(go.TextBlock, "Add Employee",
            {
              margin: new go.Margin(10, 10, 10, 10)
            }
          ),
          {
            click: (e: any, button: any) => addEmployee(button.part.adornedPart)
          }
        ),
        // $$("ContextMenuButton",
        //   $$(go.TextBlock, "Vacate Position"),
        //   {
        //     click: (e: any, button: any) => {
        //       const node = button.part.adornedPart;
        //       if (node !== null) {
        //         const thisemp = node.data;
        //         MyDiagramState.startTransaction("vacate");
        //         // update the key, name, picture, and comments, but leave the title
        //         MyDiagramState.model.setDataProperty(thisemp, "name", "(Vacant)");
        //         MyDiagramState.model.setDataProperty(thisemp, "pic", "");
        //         MyDiagramState.model.setDataProperty(thisemp, "comments", "");
        //         MyDiagramState.commitTransaction("vacate");
        //       }
        //     }
        //   }
        // ),
        // $$("ContextMenuButton",
        //   $$(go.TextBlock, "Remove Role"),
        //   {
        //     click: (e: any, button: any) => {
        //       // reparent the subtree to this node's boss, then remove the node
        //       const node = button.part.adornedPart;
        //       if (node !== null) {
        //         MyDiagramState.startTransaction("reparent remove");
        //         const chl = node.findTreeChildrenNodes();
        //         // iterate through the children and set their parent key to our selected node's parent key
        //         while (chl.next()) {
        //           const emp = chl.value;
        //           MyDiagramState.model.setParentKeyForNodeData(emp.data, node.findTreeParentNode().data.key);
        //         }
        //         // and now remove the selected node itself
        //         MyDiagramState.model.removeNodeData(node.data);
        //         MyDiagramState.commitTransaction("reparent remove");
        //       }
        //     }
        //   }
        // ),
        $$("ContextMenuButton",
          $$(go.TextBlock, "Remove Employee", {
            margin: new go.Margin(10, 10, 10, 10)
          }),
          {
            click: (e: any, button: any) => {
              // remove the whole subtree, including the node itself
              const node = button.part.adornedPart;
              removeCurrentNode(node)
            }
          }
        )
      );

    // define the Link template
    MyDiagramState.linkTemplate = chartTemplate.getLinkTemplate()
    //@ts-ignore
    if (window.Inspector) myInspector = new Inspector("myInspector", MyDiagramState,
      {
        properties: {
          "key": { readOnly: true },
          "comments": {}
        }
      });

    // Setup zoom to fit button
    // document.getElementById('zoomToFit').addEventListener('click', () => MyDiagramState.commandHandler.zoomToFit());

    // document.getElementById('centerRoot').addEventListener('click', () => {
    //   MyDiagramState.scale = 1;
    //   MyDiagramState.commandHandler.scrollToPart(MyDiagramState.findNodeForKey(1));
    // });
  } // end init







  return (
    <div
      style={{
        // backgroundImage:
          // "linear-gradient(#e8ecef 1px, transparent 0.1px), linear-gradient(to right, #E8ECEF 1px, #ffffff 1px)",
        opacity: "0.8",
        backgroundSize: "8px 8px",
        backgroundColor: "#F5F5F5",
        overflow: "auto"
      }}
    >
      <div
        id="myDiagram"
        style={{ height: "900px", border: "solid 0px;" }}
      ></div>
      <button onClick={() => { addEmployee(currentNodeState) }}>Add Employee</button>
      <button onClick={() => { removeCurrentNode(currentNodeState) }}>Remove Employee</button>
      <div>
        name : <input value={currentName} onChange={(e) => {
          setCurrentName(e.target.value)
        }}></input>
        position : <input value={currentPosition} onChange={(e) => {
          setCurrentPosition(e.target.value)
        }}></input>
        profile url : <input value={currentUrl} onChange={(e) => {
          setCurrentUrl(e.target.value)
        }}></input>
      </div>
      <div>
        <button onClick={() => { updateCurrentNode() }}>Save</button>
      </div>
      <div>
        <button onClick={() => { getDataFromDiagram() }}>get</button>
      </div>

    </div>
  );
};

export default OrgChart;
